import queryString from 'query-string';
/** Filtering empty inputs and creates a query string for the test request. */
export const generateTestQueryString = (parameters) => {
    const filtered = Object.entries(parameters).reduce((acc, [_key, parameter]) => {
        if (parameter.id && parameter.value) {
            return Object.assign(Object.assign({}, acc), { [parameter.id]: parameter.value.trim() });
        }
        return acc;
    }, {});
    const qs = queryString.stringify(filtered);
    return qs ? `?${qs}` : '';
};
